export const color = {
  line: ["#6398F5", "#28C6DA", "#3CDAAF", "#F9826F", "#9575CD", "#F6CB5F"],
  scatter: ["#5082F2", "#F9826F"],
  bar: [
    "#5082F2",
    "#F9826F",
    "#3CDAAF",
    "#F6CB5F",
    "#6FC2EF",
    "#80DD80",
    "#C1D85A",
    "#9575CD"
  ]
};

/**
 * 字段映射表
 */
export const fieldsMapper = [
  { name: "销量", type: "normal", unit: "辆" },
  { name: "份额", type: "percent", unit: "%" }
];

export const sizeMap = {
  small: {
    width: 1316,
    height: 784
  },
  medium: {
    width: 1380,
    height: 784
  },
  large: {
    width: 1380,
    height: 842
  }
};
/**
 * 个别页面需要越权显示的数据
 */
export const ultraViresMenu = [
  {
    id: "1017",
    key: "1017",
    title: "行业新闻",
    icon: null,
    path: "/news:8108",
    videoUrl: "https://iw.waysdata.com/waysresource/video/func/22.mp4",
    memo: "通过偏好推荐聚焦媒体新闻，从车型维度打通舆情数据，挖掘全方位信息",
    type: 0,
    children: [
      {
        id: "2076",
        key: "2076",
        title: "新闻舆情",
        icon: null,
        path: "#",
        videoUrl: null,
        memo: null,
        type: 1,
        children: [
          {
            id: "20761",
            key: "20761",
            title: "新闻舆情",
            icon: null,
            path: "/news/news",
            videoUrl: null,
            memo: null,
            type: 1,
            children: []
          }
        ]
      }
    ],
    special: true // 表示后台没有配置行业新闻 单页面上有个别入口需要显示
  },
  {
    id: "1018",
    key: "1018",
    title: "行业政策",
    icon: null,
    path: "/policy:8113",
    videoUrl: "https://iw.waysdata.com/waysresource/video/func/21.mp4",
    memo: "汇聚海量行业政策信息，并提供政策量化解读与专题分析",
    type: 0,
    children: [
      {
        id: "2077",
        key: "2077",
        title: "政策信息",
        icon: null,
        path: "#",
        videoUrl: null,
        memo: null,
        type: 1,
        children: [
          {
            id: "20771",
            key: "20771",
            title: "政策首页",
            icon: null,
            path: "/policy/home",
            videoUrl: null,
            memo: null,
            type: 1,
            children: []
          },
          {
            id: "20772",
            key: "20772",
            title: "政策列表",
            icon: null,
            path: "/policy/policies",
            videoUrl: null,
            memo: null,
            type: 1,
            children: []
          },
          {
            id: "20773",
            key: "20773",
            title: "政策搜索",
            icon: null,
            path: "/policy/search",
            videoUrl: null,
            memo: null,
            type: 1,
            children: []
          }
        ]
      },
      {
        id: "2078",
        key: "2078",
        title: "行业报告",
        icon: null,
        path: "#",
        videoUrl: null,
        memo: null,
        type: 1,
        children: [
          {
            id: "20781",
            key: "20781",
            title: "公共报告",
            icon: null,
            path: "/policy/reports-public",
            videoUrl: null,
            memo: null,
            type: 1,
            children: []
          },
          {
            id: "20782",
            key: "20782",
            title: "专题报告",
            icon: null,
            path: "/policy/reports-special",
            videoUrl: null,
            memo: null,
            type: 1,
            children: []
          }
        ]
      },
      {
        id: "2079",
        key: "2079",
        title: "新能源专题",
        icon: null,
        path: "#",
        videoUrl: null,
        memo: null,
        type: 1,
        children: [
          {
            id: "20791",
            key: "20791",
            title: "新能源行业目录专题",
            icon: null,
            path: "/policy/newenergycatalog",
            videoUrl: null,
            memo: null,
            type: 1,
            children: []
          },
          {
            id: "20794",
            key: "20794",
            title: "新能源补贴车型详情",
            icon: null,
            path: "/policy/newenergycardetail",
            videoUrl: null,
            memo: null,
            type: 1,
            children: []
          },
          {
            id: "20793",
            key: "20793",
            title: "新能源补贴车型列表",
            icon: null,
            path: "/policy/newenergycar",
            videoUrl: null,
            memo: null,
            type: 1,
            children: []
          },
          {
            id: "20792",
            key: "20792",
            title: "新能源补贴政策概览",
            icon: null,
            path: "/policy/newenergy",
            videoUrl: null,
            memo: null,
            type: 1,
            children: []
          }
        ]
      }
    ],
    special: true // 表示后台没有配置行业政策 单页面上有个别入口需要显示
  }
];
